import { IntegrationType } from '@vizsla/types';
export const INTEGRATION_AMPLY_TYPE = IntegrationType.Amply;
export const INTEGRATION_DOUBLE_THE_DONATION_TYPE = IntegrationType.DoubleTheDonation;
/** https://8base-dev.atlassian.net/browse/VSL-689 */
export const INTEGRATION_FACEBOOK_TYPE = IntegrationType.Facebook;
